import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';



const Khadamet = () => {
    const mediaItems = [
        {
            type: 'video',
            src: require('./images/khadamet.mp4'),
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">Khadamet</h2>
        <span className="section__subtitle">Legal Platform for Tunisian Entrepreneurs</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>
                    Khadamet is a comprehensive legal platform designed specifically for Tunisian entrepreneurs. 
                    The platform provides essential guidance on legal understanding and auto-entrepreneur status regulations in Tunisia.
                </p>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Core Services</h4>
                <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>⚖️ Legal Understanding</strong> - Comprehensive guidance on Tunisian business laws and regulations
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🏢 Auto-Entrepreneur Status</strong> - Step-by-step guidance on obtaining and maintaining auto-entrepreneur status
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📋 Status Requirements</strong> - Clear explanations of legal requirements and obligations
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📰 Real-time Legal Updates</strong> - MCP integration for latest Tunisian law announcements
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🇹🇳 Tunisia-Specific</strong> - Tailored exclusively for Tunisian entrepreneurial landscape
                    </li>
                </ul>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Key Features</h4>
                <p className='redRadio__text'>
                    Advanced MCP system that continuously monitors Tunisian legal announcements, ensuring entrepreneurs 
                    receive the most current and relevant legal information for their business decisions.
                </p>
                <br />
                
                <p className='redRadio__text' style={{fontStyle: 'italic'}}>
                    Empowering Tunisian entrepreneurs with essential legal knowledge and real-time regulatory updates.
                </p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level">Backend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">MCP</h3>
                <span className="skills__level">Integration</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">LLMs</h3>
                <span className="skills__level">AI</span>
            </div>
            </div>


        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">ReactJS</h3>
                <span className="skills__level">Frontend</span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">RAG</h3>
                <span className="skills__level">Architecture</span>
              </div>
            </div>
                        <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Scrapping</h3>
                <span className="skills__level">Data</span>
            </div>
            </div>
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default Khadamet;